export class AppAttachment {
  constructor(
    public id: number,
    public metadata: string,
    public name: string,
    public messageId: number,
    public status?: string,
  ) {
  }
}
